import { Component } from '@angular/core';
import { ImpersonationBannerComponent } from './impersonation';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <app-impersonation-banner></app-impersonation-banner>
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout [class.impersonation-active]="hasImpersonationBanner"></abp-dynamic-layout>
  `,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  get hasImpersonationBanner(): boolean {
    return !!localStorage.getItem('impersonation_status');
  }
}
